// src/hooks/useLanguage.js
import { useState, useEffect, useCallback } from 'react';

export const useLanguage = () => {
  const [language, setLanguage] = useState('en');

  const updateDocumentLanguage = useCallback((lang) => {
    // Update document direction and language
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    
    // Update page title based on language
    if (lang === 'ar') {
      document.title = 'مصرف مكين الرقمي - الخدمات المصرفية أصبحت بسيطة';
    } else {
      document.title = 'Makeen Digital Bank - Banking Made Simple';
    }
  }, []);

  useEffect(() => {
    // Check for saved language preference in localStorage
    const savedLanguage = localStorage.getItem('makeen-language');
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'ar')) {
      setLanguage(savedLanguage);
      updateDocumentLanguage(savedLanguage);
    } else {
      // Try to detect browser language
      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang.startsWith('ar')) {
        setLanguage('ar');
        updateDocumentLanguage('ar');
      }
    }
  }, [updateDocumentLanguage]);

  const changeLanguage = useCallback((lang) => {
    if (lang === 'en' || lang === 'ar') {
      // Force state update by using functional form
      setLanguage(prevLang => {
        if (prevLang !== lang) {
          localStorage.setItem('makeen-language', lang);
          updateDocumentLanguage(lang);
          
          // Dispatch custom event for other components to listen to
          window.dispatchEvent(new CustomEvent('languageChange', { 
            detail: { language: lang, previousLanguage: prevLang } 
          }));
        }
        return lang;
      });
    }
  }, [language, updateDocumentLanguage]);

  const isRTL = language === 'ar';

  return { 
    language, 
    changeLanguage, 
    isRTL,
    // Helper methods
    isArabic: language === 'ar',
    isEnglish: language === 'en'
  };
};

export default useLanguage;